export default __webpack_public_path__ + "static/media/susie2.bbd277b8.jpg";